function toBmiNumber(value) {
  if (typeof value !== 'string') {
    return Number(value);
  }

  return Number(value.replace(',', '.'));
}

function getMatchingBmiRange(ranges, bmi) {
  let match = null;

  ranges.forEach((range) => {
    if (bmi >= range.min) {
      match = range;
    }
  });

  return match || ranges[0] || null;
}

function initBmiCalculator() {
  const calculators = document.querySelectorAll('.js-bmi-calculator');
  if (!calculators.length) return;

  calculators.forEach((calculator) => {
    const ranges = JSON.parse(calculator.dataset.ranges || '[]')
      .map((range) => ({
        min: toBmiNumber(range.min),
        classification: range.classification || '',
        content: range.content || '',
      }))
      .filter((range) => Number.isFinite(range.min))
      .sort((a, b) => a.min - b.min);

    const step1 = calculator.querySelector('.js-bmi-step-1');
    const step2 = calculator.querySelector('.js-bmi-step-2');
    const lengthInput = calculator.querySelector('.js-bmi-length');
    const weightInput = calculator.querySelector('.js-bmi-weight');
    const calculateButton = calculator.querySelector('.js-bmi-calculate');
    const resetButton = calculator.querySelector('.js-bmi-reset');
    const errorOutput = calculator.querySelector('.js-bmi-error');
    const bmiValueOutput = calculator.querySelector('.js-bmi-value');
    const classificationOutput = calculator.querySelector('.js-bmi-classification');
    const contentOutput = calculator.querySelector('.js-bmi-content');

    if (!step1 || !step2 || !lengthInput || !weightInput || !calculateButton || !resetButton) {
      return;
    }

    const setStep = (step) => {
      const showStep1 = step === 1;

      step1.hidden = !showStep1;
      step2.hidden = showStep1;
      step1.classList.toggle('is-active', showStep1);
      step2.classList.toggle('is-active', !showStep1);
    };

    const showError = (message) => {
      if (!errorOutput) return;
      errorOutput.textContent = message;
      errorOutput.hidden = false;
    };

    const clearError = () => {
      if (!errorOutput) return;
      errorOutput.textContent = '';
      errorOutput.hidden = true;
    };

    setStep(1);

    calculateButton.addEventListener('click', () => {
      clearError();

      const length = toBmiNumber(lengthInput.value);
      const weight = toBmiNumber(weightInput.value);

      if (!Number.isFinite(length) || length < 120 || length > 230) {
        showError('Vul een geldige lengte in tussen 120 en 230 cm.');
        return;
      }

      if (!Number.isFinite(weight) || weight < 35 || weight > 250) {
        showError('Vul een geldig gewicht in tussen 35 en 250 kg.');
        return;
      }

      const bmi = weight / ((length / 100) * (length / 100));
      const roundedBmi = Math.round(bmi * 10) / 10;
      const matchedRange = getMatchingBmiRange(ranges, roundedBmi);

      if (bmiValueOutput) {
        bmiValueOutput.textContent = roundedBmi.toFixed(1);
      }

      if (classificationOutput) {
        classificationOutput.textContent = matchedRange ? matchedRange.classification : '';
      }

      if (contentOutput) {
        contentOutput.innerHTML = matchedRange ? matchedRange.content : '';
      }

      setStep(2);
    });

    resetButton.addEventListener('click', () => {
      clearError();
      setStep(1);
    });
  });
}
